document.addEventListener('DOMContentLoaded', function() {
    const carousels = document.querySelectorAll('.hero-carousel');
    if (!carousels.length) return;
    
    carousels.forEach(carousel => {
        const slides = carousel.querySelectorAll('.hero-carousel-slide');
        const indicators = carousel.querySelectorAll('.indicator');
        const interval = parseInt(carousel.dataset.interval) || 4000;
        
        let currentSlide = 0;
        let isTransitioning = false;
        let autoplayTimer;
        
        function resetZoom(slideIndex) {
            let slide = slides[slideIndex];
            setTimeout(() => {
                slide.classList.remove('zooming');
            }, 600);
        }
        
        function startZoom(slideIndex) {
            let slide = slides[slideIndex];        
            slide.classList.add('zooming');
        }
        
        function goToSlide(index) {
            if (isTransitioning || index === currentSlide) return;
            
            isTransitioning = true;
            clearTimeout(autoplayTimer);

            // Start zoom effect for new slide
            startZoom(index);
            
            // Remove active class from current slide and indicator
            slides[currentSlide].classList.remove('active');
            indicators[currentSlide].classList.remove('active');
            
            // Add fade-out effect
            slides[currentSlide].classList.add('fade-out');
            
            setTimeout(() => {
                // Remove fade-out and activate new slide
                slides[currentSlide].classList.remove('fade-out');

                // Reset zoom on current slide before transition
                const zoomingSlide = currentSlide;
                resetZoom(zoomingSlide);
                
                slides[index].classList.add('active');
                indicators[index].classList.add('active');
                
                currentSlide = index;
                
                // Wait for fade-in to complete before allowing next transition
                setTimeout(() => {
                    isTransitioning = false;
                }, 400);
                
                // Always restart autoplay after any slide change
                startAutoplay();
            }, 0);
        }
        
        function nextSlide() {
            const next = (currentSlide + 1) % slides.length;
            goToSlide(next);
        }
        
        function startAutoplay() {
            autoplayTimer = setTimeout(nextSlide, interval);
        }
        
        // Initialize this carousel
        startAutoplay();
        
        // Start zoom for initial slide
        startZoom(0);
        
        // Add click handlers to indicators for this carousel
        indicators.forEach((indicator, index) => {
            indicator.addEventListener('click', () => goToSlide(index));
        });
        
        // Pause on hover for this carousel
        carousel.addEventListener('mouseenter', () => {
            clearTimeout(autoplayTimer);
        });
        
        carousel.addEventListener('mouseleave', () => {
            if (!isTransitioning) {
                startAutoplay();
            }
        });
    });
});
